import React from 'react';

export const Grabber: React.FC = () => (
  <svg
    width="12px"
    height="19px"
    viewBox="0 0 12 19"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <g id="Specs_Web_Wedding-Party" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g id="Artboard" transform="translate(-164.000000, -906.000000)" fill="#71777F">
        <g id="new-grabber" transform="translate(164.000000, 906.000000)">
          <circle id="Oval" cx="10.5" cy="1.5" r="1.5" />
          <circle id="Oval-Copy-3" cx="1.5" cy="1.5" r="1.5" />
          <circle id="Oval-Copy" cx="10.5" cy="9.5" r="1.5" />
          <circle id="Oval-Copy-4" cx="1.5" cy="9.5" r="1.5" />
          <circle id="Oval-Copy-2" cx="10.5" cy="17.5" r="1.5" />
          <circle id="Oval-Copy-5" cx="1.5" cy="17.5" r="1.5" />
        </g>
      </g>
    </g>
  </svg>
);
